var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetsoft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 308.6 99.9",
    style: {
      enableBackground: "new 0 0 308.6 99.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M57.9,47.9c1.7-2.6,2.6-5.7,2.6-8.8l0-22.8c0-0.5,0-1,0-1.4c-0.3-4.1-2.1-7.9-5.2-10.6 c-3-2.8-7-4.4-11.1-4.3H29.1v47.9H57.9z M47.8,12.3c1,0.9,1.6,2.2,1.7,3.6l0,0.5l0,22.8c0,3-2.4,5.4-5.4,5.4c0,0,0,0,0,0h-4.4V10.9 h4.3C45.4,10.8,46.8,11.4,47.8,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M61.5,59.5c-0.2-2.6-1-5.2-2.5-7.4H29.1V100h16.2c4.3,0.1,8.5-1.7,11.5-4.8c3.1-3,4.8-7.2,4.8-11.5 l0-22.8C61.5,60.4,61.5,59.9,61.5,59.5z M50.6,83.7c0,1.5-0.6,2.9-1.6,3.9c-1,1-2.3,1.6-3.7,1.6h-5.4V55.5h5.4 c1.3,0,2.6,0.5,3.6,1.4c1,0.9,1.6,2.2,1.7,3.6l0,0.5L50.6,83.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "264.8,47.8 275.6,47.8 275.6,10.9 285.4,10.9 285.4,0 254,0 254,10.9 264.8,10.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "264.8,52 264.8,100 275.6,100 275.6,52 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "249.8,47.8 249.8,44.5 232.4,44.5 232.4,10.9 249.8,10.9 249.9,0 221.5,0 221.5,47.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "221.5,52 221.5,100 232.4,100 232.5,55.4 249.9,55.4 249.9,52 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.7,47.8l0-31.5c0-1.5,0.6-2.9,1.6-3.9c2-2,5.3-2.1,7.4-0.2c1,0.9,1.6,2.2,1.7,3.6l0,0.5v31.5 h10.8V16.3c0-0.5,0-1,0-1.4c-0.3-4.1-2.1-7.9-5.2-10.6c-3-2.8-6.9-4.3-11-4.2c-4.3-0.1-8.4,1.7-11.4,4.8c-3.1,3-4.8,7.2-4.8,11.5 v31.5L192.7,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.5,52v31.7c0,3-2.4,5.4-5.4,5.5c-2.9,0-5.2-2.2-5.4-5c0-0.2,0-0.3,0-0.5l0-31.7H182v31.7 c0,0.5,0,1,0,1.4c0.3,4.1,2.1,7.9,5.2,10.6c6.4,5.9,16.2,5.7,22.3-0.5c3.1-3,4.8-7.2,4.8-11.5V52L203.5,52L203.5,52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M148.4,47.8H166c-2-1.6-3.9-3.3-5.9-4.9c-3.5-3.2-5.5-7.3-5.9-12.2c-0.1-0.8-0.1-1.6-0.1-2.5l0.1-12 c0-3,2.4-5.4,5.4-5.4c1.3,0,2.6,0.5,3.6,1.4c1,0.9,1.6,2.2,1.7,3.6l0,0.5v7.6h10.8v-7.6c0-0.5,0-1,0-1.4c-0.3-4.1-2.1-7.9-5.2-10.6 c-6.4-5.9-16.2-5.7-22.3,0.5c-3.1,3-4.8,7.2-4.8,11.5l0,15.2c0,1.2,0,2.4,0.1,3.6C144,40.2,145.6,44.4,148.4,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.6,52h-17.7c2,1.7,4.1,3.4,6.2,5.1c3.5,3.2,5.3,7.3,5.7,12.2c0.1,0.8,0,2.6,0,2.5l0,12 c0,1.5-0.6,2.9-1.7,3.9c-2.1,2-5.3,2.1-7.5,0.2c-1-0.9-1.6-2.2-1.7-3.6c0-0.2,0-0.3,0-0.5l0.1-7.6h-10.8v7.6c0,0.5,0,1,0,1.4 c0.3,4.1,2.1,7.9,5.1,10.6c6.6,6,16.9,5.5,22.9-1.1c2.7-3,4.2-6.9,4.2-10.9l0-15.2c0-1.2,0-2.4-0.1-3.6 C175.1,59.7,173.5,55.4,170.6,52z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "115.9,47.8 126.7,47.8 126.7,10.9 136.4,10.9 136.4,0 105.1,0 105.1,10.9 115.9,10.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "115.9,52 115.8,100 126.6,100 126.7,52 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "97.4,47.8 97.4,44.5 80.1,44.5 80.1,10.9 97.3,10.9 97.4,0 69.4,0 69.3,47.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "80.1,55.4 97.4,55.5 97.4,52 69.3,52 69.3,100 97.3,100 97.4,89.1 80.1,89.1 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "0,68.5 0,30.9 18.9,49.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "308.6,68.7 308.6,31.1 289.6,49.9 "
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetsoft);
export default __webpack_public_path__ + "static/media/betsoft.3fa17b0cc9f52080c5f77fa9736015e1.svg";
export { ForwardRef as ReactComponent };